import { isRouteMenuPoint, MenuPoint, NavColor, NavColors } from '@agilox/ui-common';
import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@Component({
	selector: 'ui-nav-list-entry',
	imports: [IconModule, TooltipModule, RouterLink, NgTemplateOutlet],
	templateUrl: './nav-list-entry.component.html',
})
export class NavListEntryComponent {
	private translate = inject(TranslateService);

	menuPoint = input<MenuPoint | undefined>();
	navColor = input<NavColor>(NavColors.Dark);
	isActive = input<boolean>(false);
	isHovered = input<boolean>(false);

	isLink = computed(() => isRouteMenuPoint(this.menuPoint()));

	lang = toSignal(this.translate.onLangChange.pipe(map((event) => event.lang)), {
		initialValue: this.translate.currentLang ?? this.translate.defaultLang ?? 'en',
	});
}
